export enum CellAreaType {
    EMPTY,
    CENTER,
    HEADER,
    SIDE,
    EDGE
}
